import React from 'react';
import { Box, Typography, Alert, Chip, Grid, Skeleton, Stack } from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PersonIcon from '@mui/icons-material/Person';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PackageCard from './PackageCard';
import { PACKAGE_TYPES } from './data/packageCatalog';

export default function QuoteResults({ quote, isLoading, onAction }) {
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Skeleton variant="rounded" height={72} />
        <Grid container spacing={3}>
          {[1, 2, 3, 4].map((i) => (
            <Grid item xs={12} md={6} key={i}>
              <Skeleton variant="rounded" height={380} />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  if (!quote) {
    return (
      <Box sx={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', minHeight: 400, textAlign: 'center'
      }}>
        <Box sx={{
          width: 96, height: 96, borderRadius: '50%',
          bgcolor: 'action.hover', display: 'flex', alignItems: 'center',
          justifyContent: 'center', mb: 3
        }}>
          <DirectionsCarIcon sx={{ fontSize: 48, color: 'text.disabled' }} />
        </Box>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          Inizia un nuovo preventivo
        </Typography>
        <Typography variant="body2" color="text.disabled" sx={{ maxWidth: 400 }}>
          Compila i dati del veicolo nel pannello a sinistra e clicca "Calcola Preventivi" per visualizzare le opzioni disponibili.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {/* Quote Summary */}
      <Alert
        severity="success"
        icon={<CheckCircleOutlineIcon />}
        sx={{ alignItems: 'center' }}
      >
        <Stack direction="row" flexWrap="wrap" gap={1} alignItems="center">
          <Typography variant="body2" fontWeight={700}>Preventivo calcolato</Typography>
          <Chip size="small" icon={<LocationOnIcon />} label={`${quote.province} - Zona ${quote.zone}`} variant="outlined" />
          {quote.vehicleInfo && (
            <Chip size="small" icon={<DirectionsCarIcon />} label={quote.vehicleInfo} variant="outlined" />
          )}
          <Chip size="small" icon={<CalendarTodayIcon />} label={`${quote.duration} mesi`} variant="outlined" />
          <Chip size="small" icon={<PersonIcon />} label={quote.customerName || 'Anonimo'} variant="outlined" />
        </Stack>
      </Alert>

      {/* Package Cards */}
      <Grid container spacing={3}>
        {Object.values(PACKAGE_TYPES).map((packageType) => (
          <Grid item xs={12} md={6} key={packageType}>
            <PackageCard
              quote={quote}
              packageType={packageType}
              onAction={onAction}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}